export enum EstadosTransferenciaManual {
    ABIERTA = 'ABIERTA',
    CERRADA = 'CERRADA',
  }
  